import { ReactElement } from 'react';

interface modalProps{
    isChange: boolean
}

export function PassResetModal(props: modalProps){
    let message = "";
    if(props.isChange){
        message = '既にパスワードは変更済みです！'
    }else{
        message = 'パスワードの変更が完了しました。'
    }
    return(
        <div className="overlay-box">
            <div className="modal-box">
                <div className="modal-base">
                    <div className="mdl-wrap">
                        <div className="mdl-cont">
                            <dl className="mdl-dl">
                                <dt>{message}</dt>
                                <div className="btn-area">
                                    <div className="flex-center is-col">
                                        <a href="/login" className="btn-main btnsz-l">ログイン画面へ</a>
                                    </div>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}